import { Alert } from '@mui/material';
import { useEffect, useState } from 'react';
import { useFeatureFlagsStore } from '../../store/storeFeatureFlags';

export const MAINTENANCE_MESSAGE =
  'You may experience disruption to services. We are currently working on system maintenance that will be concluded shortly';

interface MaintenanceAlertProps {
  leftOffset?: number | string;
}

const MaintenanceAlert = ({ leftOffset }: MaintenanceAlertProps) => {
  const isEnabled = useFeatureFlagsStore(
    state => state.isMaintenanceBannerEnabled,
  );
  const fetchFlags = useFeatureFlagsStore(state => state.fetchFlags);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    fetchFlags();
  }, [fetchFlags]);

  if (!isEnabled || !open) return null;
  const isFixed = leftOffset !== undefined;
  return (
    <Alert
      severity="warning"
      onClose={() => setOpen(false)}
      sx={{
        borderRadius: 0,
        ...(isFixed
          ? {
              position: 'fixed',
              top: 0,
              left: leftOffset,
              right: 0,
              zIndex: theme => theme.zIndex.appBar - 1,
            }
          : {}),
      }}
    >
      {MAINTENANCE_MESSAGE}
    </Alert>
  );
};

export default MaintenanceAlert;
